import React from 'react'

import { reverse } from 'named-urls'
import PerfectScrollBar from 'react-perfect-scrollbar'

import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Zoom,
  IconButton,
} from '@material-ui/core'

import { Skeleton } from '@material-ui/lab'

import { routes } from 'routes'
import { useHistory } from 'react-router-dom'
import { DotStatus } from 'components'
import { Permitted } from 'components/Permissions'
import { LogIconButton } from 'components/Logs'
import helpers from 'helpers'
import { SwapHorizontalCircleOutlined } from '@material-ui/icons'

const PlansInfo = ({ contract }) => (
  <Paper>
    <Box
      p={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="h4">Planos</Typography>
    </Box>
    <Divider />
    <PerfectScrollBar>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell>Cobranças efetuadas</TableCell>
            <TableCell>Descontos lançados</TableCell>
            <TableCell align="right">Valor</TableCell>
            <TableCell align="right">Desconto</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell></TableCell>
            <Permitted admin>
              <TableCell align="right"></TableCell>
            </Permitted>
          </TableRow>
        </TableHead>
        <TableBody>
          {contract &&
            contract.contractPlans.map((contractPlan, index) => {
              if (contractPlan) {
                return (
                  <ItemRow
                    contract={contract}
                    contractPlan={contractPlan}
                    key={index}
                    id={contractPlan.id}
                    planName={contractPlan.plan && contractPlan.plan.name}
                    charges={helpers.contractPlans.charges(contractPlan)}
                    entryCharges={helpers.contractPlanEntries.charges(
                      contractPlan && contractPlan.contractPlanEntries,
                    )}
                    value={helpers.currency(contractPlan.price)}
                    entryValue={helpers.currency(
                      helpers.contractPlanEntries.price(
                        contractPlan.contractPlanEntries,
                      ),
                    )}
                    status={contractPlan.status}
                  />
                )
              }

              return <SkeletonRow key={index} />
            })}
        </TableBody>
      </Table>
    </PerfectScrollBar>
    <Box p={2} display="flex" justifyContent="flex-end">
      <Typography variant="h4" component="strong">
        {`Valor total: ${helpers.currency(contract.totalPrice)}`}
      </Typography>
    </Box>
  </Paper>
)

const ItemRow = ({
  contract,
  contractPlan,
  id,
  planName,
  charges,
  entryCharges,
  value,
  entryValue,
  status,
}) => {
  const history = useHistory()

  const migratePlan = (contract, contractPlan) => {
    history.push(
      reverse(routes.contracts.migratePlan.steps.show, {
        contractId: contract.id,
        contractPlanId: contractPlan.id,
      }),
    )
  }

  return (
    <TableRow hover>
      <TableCell>{planName}</TableCell>
      <TableCell>{charges}</TableCell>
      <TableCell>{entryCharges}</TableCell>
      <TableCell align="right">{value}</TableCell>
      <TableCell align="right">{entryValue}</TableCell>
      <TableCell align="center">
        <DotStatus
          statusName={helpers.contractPlans.status(status)}
          statusTag={status}
        />
      </TableCell>
      <Permitted admin>
        <TableCell align="right">
          <LogIconButton
            to={reverse(routes.contractPlans.logs, {
              contractPlanId: id,
            })}
          />
        </TableCell>
      </Permitted>
      <TableCell align="center">
        <IconButton
          onClick={() => migratePlan(contract, contractPlan)}
          disabled={
            helpers.contractPlans.checkStatus.show(status) ||
            helpers.contracts.checkStatus.show(contract.status)
          }
        >
          <Tooltip TransitionComponent={Zoom} title="Migrar plano">
            <SwapHorizontalCircleOutlined fontSize="large" />
          </Tooltip>
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

const SkeletonRow = () => (
  <TableRow>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
  </TableRow>
)
export default PlansInfo
